// src/hooks/use-event.tsx
import { useMemo } from "react";
var useEvent = (type, options) => {
  const event = useMemo(() => new Event(type, options), [type, options]);
  return event;
};
var use_event_default = useEvent;
export { use_event_default };